"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getEnsuredAppIdFromProcessor_1 = __importDefault(require("../getEnsuredAppIdFromProcessor"));
const General_1 = require("../../types/General");
const jsonStringifyRecursive_1 = __importDefault(require("../../shared/jsonStringifyRecursive"));
const buildCallableDebugLog = ({ axios, hostname, }) => async ({ processor, entryVars, }) => {
    var _a;
    if (!processor.root.isInDevelopment) {
        return;
    }
    const appId = (0, getEnsuredAppIdFromProcessor_1.default)('DebugLog', processor);
    const content = entryVars[General_1.DEFINITION_PROP_NAMES.CONTENT];
    // eslint-disable-next-line no-console
    console.log(content);
    axios({
        method: 'POST',
        url: `${hostname}/previewer/app/${appId}/log`,
        data: {
            content: (0, jsonStringifyRecursive_1.default)(content),
            userId: (_a = processor.root.userUid) !== null && _a !== void 0 ? _a : null,
            platform: processor.root.platformOS,
        },
    });
};
exports.default = buildCallableDebugLog;
